export const formatCurrency = (numberData) => {
  return Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
  }).format(numberData);
};
